define([], function() {

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new function.
   * @example
   *
   * var object = { 'user': 'fred' };
   * var getter = _.constant(object);
   *
   * getter() === object;
   * // => true
   */
  function constant(value) {
    return function() {
      return value;
    };
  }

  return constant;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-amd/modern/utility/constant.js
// module id = 648
// module chunks = 0